import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const BackButton = ({ to }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(to);
  };

  return (
    <button
      onClick={handleBack}
      className="flex items-center gap-2 text-orange-400 hover:text-orange-600 transition-all duration-300 font-medium text-sm mb-6 opacity-60 hover:opacity-100"
    >
      <ArrowLeft className="w-4 h-4 transition-transform duration-300 hover:translate-x-0.5" />
      <span className="text-base">Back to PMS</span>
    </button>
  );
};

export default BackButton;